import {FC, useState} from 'react'
import {campaignType, initialValueMailing, StorageContext} from './types'

const StorageProvider: FC = ({children}) => {

  const [mailing, setMailing_] = useState<campaignType>(initialValueMailing)

  const setMailing = (newMailing: campaignType) => setMailing_(newMailing)

  return (
    <StorageContext.Provider value={{mailing, setMailing}}>
      {children}
    </StorageContext.Provider>
  )
}

export {StorageProvider}